import React, {FC} from 'react';
import { useThemeSwitch } from '../../../common/helpers/ThemeSwitch';
import { useAuth0 } from '@auth0/auth0-react';
// custom
import logo from '../../../assets/img/logo.jpg';
import { APP_VERSION } from '../../../common/state/store';

const LoginCard: FC = ()=> {
    useThemeSwitch(true);
    const { loginWithRedirect } = useAuth0();

    return <React.Fragment>
        <div className="flex justify-center">
            <div className="max-w-md m-1 bg-white rounded-lg shadow-lg dark:bg-gray-900">
                <a href="#!">
                    <img className="rounded-t-lg" src={logo}
                        alt="logo" />
                </a>
                <div className="flex flex-col items-center justify-center p-6">
                    <h2 className="mb-2 text-2xl font-medium text-gray-900 dark:text-teal-400">Power Ministries International</h2>
                    <h2 className="mb-2 text-xl font-medium text-gray-900 dark:text-teal-400">Events Registration Application</h2>
                    <p className="mb-4 text-gray-700 dark:text-gray-300 dartext-base">
                        This application will help you register for upcoming conferences, 
                        monitor your progress and communicate with our team. <br/>                        
                    </p>
                    <button
                        onClick={() => loginWithRedirect()}                      
                        className="flex justify-around px-8 py-3 text-base font-bold text-gray-200 uppercase transition duration-150 ease-in-out bg-blue-700 rounded-full shadow-md focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg" type="button">
                        Sign in to Continue
                    </button>                    
                    <p className="my-4 text-gray-700 dark:text-gray-300 dartext-base">v{APP_VERSION}</p>
                </div>
            </div>
        </div>
    </React.Fragment>;
};

export default LoginCard;
